import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AudioInputOutputIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AudioInputOutput",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.74 15.98v3.73c0 1.34-.93 2.51-2.24 2.81a7.69 7.69 0 0 1-6.17 6.17c-.21.77-.91 1.3-1.7 1.3h-2.17c-.98 0-1.77-.79-1.77-1.77v-.2c-.02-.98.76-1.78 1.74-1.8h2.18c.66 0 1.27.37 1.56.97a6.23 6.23 0 0 0 4.85-4.59h-.13c-1.59.02-2.9-1.26-2.92-2.86v-3.76c0-1.29.86-2.43 2.11-2.78-.31-4.69-3.93-8.44-8.22-8.44s-7.87 3.7-8.21 8.37a2.91 2.91 0 0 1 2.37 2.84v3.73c0 1.59-1.29 2.89-2.89 2.89h-.99c-1.59 0-2.89-1.29-2.89-2.89v-3.73c0-1.2.75-2.27 1.88-2.69.28-6.25 5.05-11.29 10.76-11.29s10.4 4.98 10.73 11.2a2.88 2.88 0 0 1 2.12 2.78Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.43 14.72c-.63 0-1.14-.51-1.14-1.14v-3.43C5.29 4.47 9.9-.14 15.57-.14s10.29 4.61 10.29 10.29v3.43a1.14 1.14 0 1 1-2.28 0v-3.43c0-4.41-3.59-8-8-8s-8 3.59-8 8v3.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.09 25h-.76c-2.31 0-4.19-1.88-4.19-4.19v-4.19c0-2.31 1.88-4.19 4.19-4.19h.76c2.31 0 4.19 1.88 4.19 4.19v4.19c0 2.31-1.88 4.19-4.19 4.19m-.76-10.29c-1.05 0-1.9.85-1.9 1.91v4.19c0 1.05.85 1.91 1.9 1.91h.76c1.05 0 1.9-.86 1.9-1.91v-4.19c0-1.05-.85-1.91-1.9-1.91zM6.81 25h-.76c-2.31 0-4.19-1.88-4.19-4.19v-4.19c0-2.31 1.88-4.19 4.19-4.19h.76c2.31 0 4.19 1.88 4.19 4.19v4.19C11 23.12 9.12 25 6.81 25m-.76-10.29c-1.05 0-1.9.85-1.9 1.91v4.19c0 1.05.85 1.91 1.9 1.91h.76c1.05 0 1.9-.86 1.9-1.91v-4.19c0-1.05-.85-1.91-1.9-1.91z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19 31.86h-2.29a1.14 1.14 0 1 1 0-2.28H19c2.52 0 4.57-2.05 4.57-4.57v-1.14a1.14 1.14 0 1 1 2.28 0v1.14c0 3.78-3.08 6.86-6.86 6.86Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.28 28.43h4.57v2.29h-4.57z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.86 31.86h-4.57c-.63 0-1.14-.51-1.14-1.14v-2.29c0-.63.51-1.14 1.14-1.14h4.57c.63 0 1.14.51 1.14 1.14v2.29c0 .63-.51 1.14-1.14 1.14m-3.43-2.29h2.28z"
      })]
    })
  }));
};